import { useState } from 'react';

interface LongTextProps {
  text: string | null | undefined;
  /** Caracteres visibles antes de cortar con "…". */
  max?: number;
  className?: string;
}

/**
 * Texto largo con "ver más / ver menos": evita que una nota, un motivo o una observación
 * agrande la fila de la tabla o se desborde de la tarjeta (sobre todo en el celular).
 */
export function LongText({ text, max = 70, className = '' }: LongTextProps) {
  const [open, setOpen] = useState(false);
  const value = (text ?? '').trim();
  if (!value) return <span className="text-ink-300">—</span>;
  if (value.length <= max) return <span className={['break-words', className].join(' ')}>{value}</span>;
  return (
    <span className={['break-words', className].join(' ')}>
      {open ? value : `${value.slice(0, max).trimEnd()}…`}{' '}
      <button
        type="button"
        onClick={(e) => {
          e.stopPropagation();
          setOpen((o) => !o);
        }}
        className="whitespace-nowrap text-xs font-semibold text-brand-600 hover:underline"
      >
        {open ? 'ver menos' : 'ver más'}
      </button>
    </span>
  );
}
